import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/companies/agreements/loading';
import { getCompanyQueryOptions } from '@/_pages/companies/api-service';

export const Route = createFileRoute('/_private/companies/_template/$id/agreements')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getCompanyQueryOptions(opts.params.id)),
  staticData: {
    pageTitle: 'Agreements',
    isFullWidth: true,
    isViewOnly: true, // hides edit and delete buttons
    tabKey: 'client/agreements',
  },
  pendingComponent: Loading,
});
